import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import { isNullOrEmpty } from "../../../../../../react-core/Utils/Arrays";
import { AccountRestrictionBulkClient } from "../../../../../../Wrap/Api/Account/AccountRestrictionBulk";
import { CustomerRestrictionClient } from "../../../../../../Wrap/Api/Account/CustomerRestriction";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { ClientAccountStore } from "../../../../Stroes/Variable";
import { RestrictionDispatcher } from "./Variable";

export class RestrictionAction {
    public static getRestrictionByHierarchyId(id: string) {
        if (id == null) {
            if (
                !CommonHelper.isNullOrEmpty(getQueryParameters()["claccountid"]) &&
                ClientAccountStore.getClientAccountInfo()
            ) {
                id = ClientAccountStore.getClientAccountInfo().HierarchyId;
            } else {
                return;
            }
        }
        const client = new AccountRestrictionBulkClient();
        const promise = client.get(id);
        promise.onSuccess((data) => {
            RestrictionDispatcher.dispatch({ actionType: ActionType.Success, payload: data });
        });
        promise.onError((data) => {});
    }

    public static getRestrictionByCustomer(actorIds: Array<number>) {
        if (isNullOrEmpty(actorIds)) {
            if (!CommonHelper.isNullOrEmpty(getQueryParameters()["customerId"])) {
                actorIds = [getQueryParameters()["customerId"]];
            } else {
                return;
            }
        }
        const client = new CustomerRestrictionClient();
        const promise = client.get(actorIds);
        promise.onSuccess((data) => {
            RestrictionDispatcher.dispatch({ actionType: ActionType.Success, payload: data });
        });
        promise.onError((data) => {});
    }
}
